import { useEffect, useState } from "react";
import axios from "axios";
import { Upload, X, Loader2, Download } from "lucide-react";
import { Button } from "@/components/ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const AttachmentPreview = ({ path, image, testId }) => {
  const [url, setUrl] = useState("");
  useEffect(() => {
    let active = true;
    let blobUrl;
    axios.get(`${API}/files/${path}`, { responseType: "blob" }).then(({ data }) => {
      blobUrl = URL.createObjectURL(data);
      if (active) setUrl(blobUrl);
      else URL.revokeObjectURL(blobUrl);
    }).catch(() => {});
    return () => { active = false; if (blobUrl) URL.revokeObjectURL(blobUrl); };
  }, [path]);
  if (!url) return <span data-testid={`${testId}-loading`} className="text-sm text-zinc-400">Anhang wird geladen…</span>;
  return <a href={url} target="_blank" rel="noreferrer" download={image ? undefined : path.split("/").pop()} data-testid={testId} className="block min-w-0 break-all text-yellow-500">
    {image ? <img src={url} alt="Meldungsanhang" className="aspect-video w-full object-contain bg-zinc-950" /> : <span className="flex items-center gap-2"><Download size={16} />{path.split("/").pop()}</span>}
  </a>;
};

export const AttachmentField = ({ field, value = [], onChange, onBusy, disabled, onError }) => {
  const [uploading, setUploading] = useState(false);
  const id = `incident-field-${field.field_key}`;
  const upload = async (files) => {
    setUploading(true); onBusy(true);
    const paths = [];
    try {
      for (const file of Array.from(files || [])) {
        if (file.size > 10 * 1024 * 1024) throw new Error("Dateien dürfen höchstens 10 MB groß sein.");
        if (field.field_type === "image" && !file.type.startsWith("image/")) throw new Error("Bitte wählen Sie eine Bilddatei.");
        const body = new FormData(); body.append("file", file);
        const { data } = await axios.post(`${API}/upload`, body);
        if (!data.path) throw new Error("Der Upload hat keinen Dateipfad zurückgegeben.");
        paths.push(data.path);
      }
    } catch (error) { onError(error.message || "Upload fehlgeschlagen"); }
    finally { onChange([...value, ...paths]); setUploading(false); onBusy(false); }
  };
  return <div className="space-y-3">
    <label className="flex items-center gap-3 border border-dashed border-zinc-700 p-4 cursor-pointer hover:border-yellow-500 transition-colors">
      {uploading ? <Loader2 className="animate-spin" size={18} /> : <Upload size={18} />}
      <span className="text-sm">{uploading ? "Wird hochgeladen…" : "Dateien auswählen"}</span>
      <input id={id} data-testid={id} aria-label={field.label} type="file" multiple accept={field.field_type === "image" ? "image/*" : undefined} disabled={disabled || uploading} className="min-w-0 w-full text-sm" onChange={e => { upload(e.target.files); e.target.value = ""; }} />
    </label>
    <div className="grid gap-3 sm:grid-cols-2">
      {value.map((path, index) => <div key={`${path}-${index}`} className="min-w-0 border border-zinc-800 p-2">
        <AttachmentPreview path={path} image={field.field_type === "image"} testId={`${id}-attachment-${index}`} />
        {!disabled && <Button data-testid={`${id}-remove-${index}`} type="button" variant="ghost" size="sm" aria-label="Anhang entfernen" onClick={() => onChange(value.filter((_, i) => i !== index))}><X size={16} /> Entfernen</Button>}
      </div>)}
    </div>
  </div>;
};